export default __webpack_public_path__ + "static/media/wap_platform_introduction_pic1.71923e49.png";